import { TrainingSessionResponse, SessionFocus, AgeGroup } from '../Model';

export type SessionSortOption = 'name' | 'time-asc' | 'time-desc' | 'date-desc' | 'date-asc';

export const filterSessions = (
  sessions: TrainingSessionResponse[],
  searchQuery: string,
  filterSessionFocus: SessionFocus | 'All',
  filterAgeGroup: AgeGroup | 'All'
): TrainingSessionResponse[] => {
  return sessions.filter(response => {
    const session = response.session;

    // Text search filter (by session name)
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      const matchesName = session.name.toLowerCase().includes(query);
      if (!matchesName) return false;
    }

    // Session focus filter
    if (filterSessionFocus !== 'All' && session.sessionFocus !== filterSessionFocus) {
      return false;
    }

    // Age group filter
    if (filterAgeGroup !== 'All' && session.ageGroup !== filterAgeGroup) {
      return false;
    }

    return true;
  });
};

export const sortSessions = (
  sessions: TrainingSessionResponse[],
  sortBy: SessionSortOption
): TrainingSessionResponse[] => {
  return [...sessions].sort((a, b) => {
    const sessionA = a.session;
    const sessionB = b.session;

    switch (sortBy) {
      case 'name':
        return sessionA.name.localeCompare(sessionB.name);
      case 'time-asc':
        return sessionA.totalTime - sessionB.totalTime;
      case 'time-desc':
        return sessionB.totalTime - sessionA.totalTime;
      case 'date-desc':
        return new Date(sessionB.createdAt).getTime() - new Date(sessionA.createdAt).getTime();
      case 'date-asc':
        return new Date(sessionA.createdAt).getTime() - new Date(sessionB.createdAt).getTime();
      default:
        return 0;
    }
  });
};
